export default __webpack_public_path__ + "static/media/contribute.f7c59474.png";